const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const FrequencyAdd = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/frequency/view/add.vue');
const FrequencyEdit = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/frequency/view/edit.vue');
const FrequencyList = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/frequency/view/index.vue');
const MonetaryAdd = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/monetary/view/add.vue');
const MonetaryEdit = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/monetary/view/edit.vue');
const MonetaryList = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/monetary/view/index.vue');
const PersonaAdd = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/persona/view/add.vue');
const PersonaEdit = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/persona/view/edit.vue');
const PersonaList = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/persona/view/index.vue');
const RecencyAdd = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/recency/view/add.vue');
const RecencyEdit = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/recency/view/edit.vue');
const RecencyList = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/recency/view/index.vue');
const Segmentation = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/segmentation/edit.vue');
const RfmGroupAdd = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/group/view/add.vue');
const RfmGroupEdit = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/group/view/edit.vue');
const RfmGroupList = () => import(/* webpackChunkName: "rfm" */ '@/modules/rfm/group/view/index.vue');

export const ROUTE_NAME_RFM = {
    SEGMENTATION: 'Segmentation',
    GROUP: {
        INDEX: 'RfmGroupList',
        ADD: 'RfmGroupAdd',
        EDIT: 'RfmGroupEdit'
    },
    RECENCY: {
        INDEX: 'RecencyList',
        ADD: 'RecencyAdd',
        EDIT: 'RecencyEdit'
    },
    FREQUENCY: {
        INDEX: 'FrequencyList',
        ADD: 'FrequencyAdd',
        EDIT: 'FrequencyEdit'
    },
    MONETARY: {
        INDEX: 'MonetaryList',
        ADD: 'MonetaryAdd',
        EDIT: 'MonetaryEdit'
    },
    PERSONA: {
        INDEX: 'PersonaList',
        ADD: 'PersonaAdd',
        EDIT: 'PersonaEdit'
    }
} as const;

export default [
    {
        path: '/app/:appId/rfm/',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'segmentation',
                name: ROUTE_NAME_RFM.SEGMENTATION,
                component: Segmentation,
                meta: { requiresAuth: true }
            },
            {
                path: 'recency',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_RFM.RECENCY.INDEX,
                        component: RecencyList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_RFM.RECENCY.ADD,
                        component: RecencyAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id',
                        name: ROUTE_NAME_RFM.RECENCY.EDIT,
                        component: RecencyEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'frequency',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_RFM.FREQUENCY.INDEX,
                        component: FrequencyList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_RFM.FREQUENCY.ADD,
                        component: FrequencyAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id',
                        name: ROUTE_NAME_RFM.FREQUENCY.EDIT,
                        component: FrequencyEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'monetary',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_RFM.MONETARY.INDEX,
                        component: MonetaryList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_RFM.MONETARY.ADD,
                        component: MonetaryAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id',
                        name: ROUTE_NAME_RFM.MONETARY.EDIT,
                        component: MonetaryEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'persona',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_RFM.PERSONA.INDEX,
                        component: PersonaList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_RFM.PERSONA.ADD,
                        component: PersonaAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id',
                        name: ROUTE_NAME_RFM.PERSONA.EDIT,
                        component: PersonaEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'group',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_RFM.GROUP.INDEX,
                        component: RfmGroupList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_RFM.GROUP.ADD,
                        component: RfmGroupAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id',
                        name: ROUTE_NAME_RFM.GROUP.EDIT,
                        component: RfmGroupEdit,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
